import {createApi} from '@reduxjs/toolkit/query/react';
import { fetchBaseQuery } from '@reduxjs/toolkit/query';


var urlPrefix = '';

switch (process.env.ENVIRONMENT_SETTINGS) {
    case 'local':
        urlPrefix = 'http://localhost:5002';
        break;
    case 'staging':
        urlPrefix = '';
        break;
    case 'production':
        urlPrefix = 'https://chat.docsihealth.com';
        break;
}



export const aiAssistantSlice = createApi({
    reducerPath: 'aiAssistantApi',
    baseQuery: fetchBaseQuery({
        baseUrl: urlPrefix,
        prepareHeaders: (headers) => {
            headers.set('content-type', 'application/json');
            headers.set('accept', 'application/json');
            
            // Get the token from localStorage
            const token = localStorage.getItem('token');
                        
            // Add authorization header if token exists
            if (token) {
                headers.set('authorization', `Bearer ${token}`);
            }
            
            return headers;
        },
        credentials: 'include'
    }),
    endpoints: (builder) => ({
        createAgent: builder.mutation({
            query: (agentType) => ({
                url: '/agents',
                method: 'POST',
                body: { agent_type: agentType },
            }),
        }),
        campaignAgentPrompt: builder.mutation({
            query: (data) => ({
                url: '/campaigns',
                method: 'POST',
                body: {
                    prompt: data.prompt,
                    session_id: data.sessionId
                }
            }),
        }),
        dataExplorationAgentPrompt: builder.mutation({
            query: (data) => ({
                url: '/data-exploration',
                method: 'POST',
                body: {
                    prompt: data.prompt,
                    session_id: data.sessionId
                }
            }),
        }),


    }),
});

export const { 
    useCreateAgentMutation,
    useCampaignAgentPromptMutation,
    useDataExplorationAgentPromptMutation,
} = aiAssistantSlice;